/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroomtab_Description3Inputs */

const en_coinvestments_dataroomtab_description3 = /** @type {(inputs: Coinvestments_Dataroomtab_Description3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access deal documents and materials through the GP's data room.`)
};

/**
* | output |
* | --- |
* | "Access deal documents and materials through the GP's data room." |
*
* @param {Coinvestments_Dataroomtab_Description3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroomtab_description3 = /** @type {((inputs?: Coinvestments_Dataroomtab_Description3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroomtab_Description3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroomtab_description3(inputs)
});
export { coinvestments_dataroomtab_description3 as "coInvestments_dataRoomTab_description" }